import React from 'react';
import { components } from 'react-select';
import PropTypes from 'prop-types';

const CustomizeOption = (props) => {
    return (
        <components.Option {...props}>
            <div data-testid={props.data.value ? `event-edit.acceptance-option.${props.data.value.toLowerCase().replace(/_/g, '-')}` : undefined}>
                <strong className="title">{props.data.label}</strong>
                <div>{props.data.description}</div>
            </div>
        </components.Option>
    );
};

CustomizeOption.propTypes = {
    data: PropTypes.objectOf({
        label: PropTypes.string,
        description: PropTypes.string,
    }).isRequired,
};

export default CustomizeOption;
